export class PropertyMapper{
    public static MapProperty(source: any, target: any) {
        Object.keys(source).forEach(key => {
            target[key] = source[key];
        });
    }
}